import { render, staticRenderFns } from "./calcVesselsSpeed.vue?vue&type=template&id=da47163c&scoped=true"
import script from "./calcVesselsSpeed.vue?vue&type=script&lang=js"
export * from "./calcVesselsSpeed.vue?vue&type=script&lang=js"
import style0 from "./calcVesselsSpeed.vue?vue&type=style&index=0&id=da47163c&prod&lang=scss"
import style1 from "./calcVesselsSpeed.vue?vue&type=style&index=1&id=da47163c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da47163c",
  null
  
)

export default component.exports